
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { CartItemCode } from "@/types/cart-item";
import { Cart } from "@/types/Cart";

const { State } = namespace("Root");

@Component
export default class CartCategoryMobileQty extends Vue {
  @State("cart") cart!: Cart;
  @Prop({ default: "unknown" })
  code!: string;
  style = "display: none;";
  @Prop()
  parentRefs!: any;

  get name() {
    if (CartItemCode[this.code]?.name) {
      return CartItemCode[this.code].name;
    }
    return "";
  }

  //TODO
  /**
   * Show what is covered info modal.
   */
  showWhatsCovered() {
    this.$router.push({
      name: `compare.${this.code}`,
    });
  }

  /**
   * Increase quantity
   */
  increase() {
    this.cart.increaseOne(this.code);
  }

  /**
   * Decrease quantity
   */
  decrease() {
    this.cart.decreaseOne(this.code);
  }

  /**
   * Count the items of the current type.
   */
  get numberOfItems() {
    return this.cart.countByCode(this.code);
  }

  show() {
    this.style = "display: block;";
  }

  hide() {
    this.style = "display: none;";
  }
}
